import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  
  //fetch all budgets
  [types.GET_BUDGETS_BEGIN](state) {
    state.budgetsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_BUDGETS_SUCCESS](state, budgets) {
    state.budgetsGetError = null;
    state.budgets = budgets;
    state.budgetsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_BUDGETS_ERROR](state, err) {
    state.budgetsGetState = API_STATES.REQUEST_ERROR;
    state.budgetsGetError = err;
  },

  //delete budget
  [types.DELETE_BUDGET_BEGIN](state) {
    state.budgetDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_BUDGET_SUCCESS](state) {
    state.budgetDeleteError = null;
    state.budgetDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_BUDGET_ERROR](state, err) {
    state.budgetDeleteState = API_STATES.REQUEST_ERROR;
    state.budgetDeleteError = err;
  },

  //create budget
  [types.CREATE_BUDGET_BEGIN](state) {
    state.budgetCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_BUDGET_SUCCESS](state, data) {
    state.budgetCreateError = null
    state.budgetCreateState = API_STATES.REQUEST_SUCCESS
    state.budget = data
  },
  [types.CREATE_BUDGET_ERROR](state, err) {
    state.budgetCreateState = API_STATES.REQUEST_ERROR;
    state.budgetCreateError = err;
  },

  //update budget
  [types.UPDATE_BUDGET_BEGIN](state) {
    state.budgetUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_BUDGET_SUCCESS](state, data) {
    state.budgetUpdateError = null
    state.budget = data
    state.budgetUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_BUDGET_ERROR](state, err) {
    state.budgetUpdateState = API_STATES.REQUEST_ERROR
    state.budgetUpdateError = err
  },

  //add store budget in budget setting store section
  [types.ADD_STORE_BUDGET_BEGIN](state,storeId) {
    state.storeBudgetUpdating.push(storeId)
    state.storeBudgetCreateState = API_STATES.REQUEST_PENDING
  },
  [types.ADD_STORE_BUDGET_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.storeBudgetUpdating, data.storeId);
    state.storeBudgetUpdating.splice(index, 1);

    rootState.app.formData.storeBudgets.push(data)
    
    const store = rootState.app.companyStores.find(s => s.id === data.storeId)
    rootState.app.formData.stores.push({ id : store.id, name : store.name })
    
    const updatedRecordIndex = state.budgets.findIndex(b => b.id === rootState.app.formData.id)
    if(updatedRecordIndex+1){
      state.budgets[updatedRecordIndex] = rootState.app.formData
    }

    state.storeBudgetCreateState = API_STATES.REQUEST_SUCCESS
    state.storeBudgetCreateError = null
  },
  [types.ADD_STORE_BUDGET_ERROR](state, { err,storeId }) {
    const index = findIndex(state.storeBudgetUpdating, storeId);
    state.storeBudgetUpdating.splice(index, 1);

    state.storeBudgetCreateError = err;
    state.storeBudgetCreateState = API_STATES.REQUEST_ERROR
  },

  //delete store budget in budget setting store section
  [types.DELETE_STORE_BUDGET_BEGIN](state, storeId) {
    state.storeBudgetDeleting.push(storeId);
  },
  [types.DELETE_STORE_BUDGET_SUCCESS](state, { storeId, rootState }) {
    state.storeBudgetDeleteError = null;
    
    const index = findIndex(state.storeBudgetDeleting, storeId);
    state.storeBudgetDeleting.splice(index, 1);

    const index2 = findIndex(rootState.app.formData.storeBudgets, { storeId });
    rootState.app.formData.storeBudgets.splice(index2, 1)

    const index3 = findIndex(rootState.app.formData.stores, { id : storeId });
    rootState.app.formData.stores.splice(index3, 1)

    const updatedRecordIndex = state.budgets.findIndex(b => b.id === rootState.app.formData.id)
    if(updatedRecordIndex+1){
      state.budgets[updatedRecordIndex] = rootState.app.formData
    }
  },
  [types.DELETE_STORE_BUDGET_ERROR](state, { err, storeId }) {
    const index = findIndex(state.storeBudgetDeleting, storeId);
    state.storeBudgetDeleting.splice(index, 1);
    state.storeBudgetDeleteError = err;
  }
};

export default mutations;
